var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgModelHide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 7.13 2.62 1.29a5.864 5.864 0 0 0 -1.15.42l-1.47-.72-.5-.25-.5.25-4.48 2.2-.04.02-.48-.24v-.51l5-2.46v-5.95l.5-.21.5.21z",
    opacity: 0.33
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m6.5 0-6.5 3.2v7.47l6.12 3.01a4.59444 4.59444 0 0 1 -.82-1.5l-3.78-1.86-.52-.26v-5.67l5 2.46v4.06a6.60645 6.60645 0 0 1 1-1.11v-2.95l5-2.46v3.87a4.81243 4.81243 0 0 1 .76.12l.24-.24v-4.94zm.5 5.78-.5.25-.5-.25-4.64-2.28 4.64-2.28.5-.25.5.25 4.64 2.28zm.4131 9.3704 6.7118-6.7118.8496.8496-6.7118 6.7118zm.5968-1.0087.6608-.6608a3.04122 3.04122 0 0 1 -1.2015-1.2616 4.49539 4.49539 0 0 1 3.7247-2.1027 2.92292 2.92292 0 0 1 .7209.0601l.781-.781a6.053 6.053 0 0 0 -1.5019-.1802 5.31165 5.31165 0 0 0 -4.8061 3.0038 5.06065 5.06065 0 0 0 1.6221 1.9224zm6.4281-3.8449-.6608.6608a4.25582 4.25582 0 0 1 1.2015 1.2616 4.50769 4.50769 0 0 1 -3.7247 2.1027 4.98983 4.98983 0 0 1 -.781-.1202l-.781.781a5.35217 5.35217 0 0 0 3.8449-.3004 5.43271 5.43271 0 0 0 2.4631-2.4631 5.50866 5.50866 0 0 0 -1.562-1.9224z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgModelHide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/model-hide.dd45f1ecbb2a8dcc24dac14455713f01.svg";